export default __webpack_public_path__ + "static/media/about1.b19a9e3e.svg";